import type { StyleConfig } from '@chakra-ui/theme-tools';

const outline = {
    border: '1px solid',
    borderColor: 'slt-black.900',
    color: 'slt-black.900',
    textStyle: 'slt-body-text',
    lineHeight: '1.625rem',
    fontSize: '1.125rem',
    _disabled: {
        backgroundColor: 'slt-black.50',
        borderColor: 'slt-black.500',
    },
    _invalid: {
        borderColor: 'slt-red-error',
    },
    _focus: {
        borderColor: 'slt-black.900',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    },
    _hover: null,
};

const newStyle = {
    ...outline,
    fontFamily: 'TT Norms Pro',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0.5px',
    fontWeight: '400',
    color: 'slt-pepper.1000',
    padding: '0.5rem',
};

export const Textarea: StyleConfig = {
    variants: {
        'slt-outline': outline,
        'new-style': newStyle,
    },
    defaultProps: {
        variant: 'slt-outline',
    },
};
